var weekdayPickerThemeNative = {
  buttonSize: 40,
  border: {
    color: 'background.secondary',
    radius: 'borders.radius'
  },
  button: {
    size: 40,
    backgroundInactive: 'background',
    backgroundActive: 'primary',
    textColorInactive: 'text',
    textColorActive: 'background'
  }
};

export { weekdayPickerThemeNative };
